import * as React from 'react';
import ConvenzioneCard from './convenzioneCard.jsx';
import { connect } from 'react-redux';

import * as agui from 'arm-gui/dist/controls';
import ProdottoActions from './prodotto_actions';
import ConfirmModalDeleteV4 from '../shared/confirmModalDeleteV4.jsx'
import AppActions from '../../app/app_actions';
import { Utils, UiUtils, NumberFormatter, DateFormatter, i18n, isAuth } from 'arm-common';
import { isNullOrUndefined } from 'util';

class ListaConvenzione extends React.Component {
    constructor(props) {
        super(props);
        this.componentName = '[ListaConvenzione.jsx] ';
        this.state = {
            convenzioneToDelete: null
        }
        this.onClickEliminaConvenzione = this.onClickEliminaConvenzione.bind(this);
        this.onClickSalvaConvenzione = this.onClickSalvaConvenzione.bind(this);
        this.onClickModificaConvenzione = this.onClickModificaConvenzione.bind(this);
        this.onClickNuovaConvenzioneButton = this.onClickNuovaConvenzioneButton.bind(this);
        this.onClickAnnullaModifica = this.onClickAnnullaModifica.bind(this);
        this.showPopUP = this.showPopUP.bind(this);
        this.returnToPath = this.returnToPath.bind(this);
    }

    componentDidMount() {
        console.log(this.componentName + ' componentDidMount');
    }

    onClickSalvaConvenzione(event) {
        console.log(this.componentName + ' onClickSalvaConvenzione');
        if (isNullOrUndefined(event) || isNullOrUndefined(event.currentTarget) || isNullOrUndefined(event.currentTarget.id)) {
            return
        }
        let indexConvenzione = event.currentTarget.id;
        this.props.salvaConvenzione(indexConvenzione).then(
            resolve => {
                console.log(this.componentName + 'after delete convenzione, reload Convenzione ');
                this.props.getConvenzioneProdotto(this.props.prodotto.id);
            }, reject => {
                console.log(this.componentName + ' salvaConvenzione KO');
                this.props.handleChangeEditConvenzione(indexConvenzione, "editable", true);
            });
    }

    onClickNuovaConvenzioneButton() {
        console.log(this.componentName + ' onClickNuovaConvenzioneButton');
        this.props.creaNuovaConvenzione().then(
            resolve => {
                $("html, body").animate({ scrollTop: $(document).height() - $(window).height() });
            }
        )

    }

    onClickEliminaConvenzione(event) {
        console.log(this.componentName + ' onClickEliminaConvenzione');
        // if (isNullOrUndefined(event) || isNullOrUndefined(event.currentTarget) || isNullOrUndefined(event.currentTarget.id)) {
        //     return
        // }
        this.props.showPopUP(false);
        let conId = this.state.convenzioneToDelete;
        this.props.deleteConvenzione(conId).then(
            resolve => {
                console.log(this.componentName + 'after delete Convenzione, reload Convenzione list');
                //l'idProdotto è sempre lo stesso su tutti gli Convenzione quindi prendo il primo
                this.props.getConvenzioneProdotto(this.props.prodotto.id);
            }, reject => {
                console.log(this.componentName + ' deleteConvenzione KO');
            });
    }

    onClickModificaConvenzione(event) {
        console.log(this.componentName + ' onClickModificaConvenzione');
        if (isNullOrUndefined(event) || isNullOrUndefined(event.currentTarget) || isNullOrUndefined(event.currentTarget.id)) {
            return
        }
        let indexConvenzione = event.currentTarget.id;
        let convenzione = this.props.listProdottoConvenzione[indexConvenzione];
        if (convenzione) {
            this.props.handleChangeEditConvenzione(indexConvenzione, "editable", true)

        }
    }

    onClickAnnullaModifica(event) {

        if (isNullOrUndefined(event) || isNullOrUndefined(event.currentTarget) || isNullOrUndefined(event.currentTarget.id)) {
            return
        }
        let indexConvenzione = event.currentTarget.id;
        this.props.handleChangeEditConvenzione(indexConvenzione, "editable", false).then(
            resolve => {
                console.log(this.componentName + 'after delete linea, reload Linea ');
                //l'idProdotto è sempre lo stesso su tutti gli Linea quindi prendo il primo
                this.props.getConvenzioneProdotto(this.props.prodotto.id);
            }, reject => {
                console.log(this.componentName + ' deleteLinea KO');
            });
    }

    showPopUP(e) {
        console.log(this.componentName + ' showPopUP');

        let convenzioneToDelete;
        if (e !== undefined && e !== null) {
            convenzioneToDelete = e.currentTarget.id;
        }
        this.setState({ convenzioneToDelete: convenzioneToDelete })

        this.props.showPopUP(!this.props.showPopUp);
    }

    returnToPath() {
        console.log(this.componentName + ' returnToPath');
        let url = this.props.pathToReturn;
        this.props.history.push({ pathname: url });
    }


    render() {
        let listProdottoConvenzione = this.props.listProdottoConvenzione;
        return (
            <agui.aCardV4>

                <agui.aCardV4Header>
                    <agui.aButton onClick={this.onClickNuovaConvenzioneButton} className="btn btn-primary float-right" icon="fas fa-plus" > {i18n('ARM_CORE_PRODUCT.SHARED.NUOVO', 'Nuovo')} </agui.aButton>
                    < div className='d-flex flex-row ' >
                        {/* <agui.aButton onClick={this.returnToPath} className="btn btn-primary p-2" title={i18n('ARM_CORE_PRODUCT.SHARED', "Indietro")} icon="fas fa-angle-left" /> */}

                        <h3 className="p-2" >{i18n('ARM_CORE_PRODUCT.PRODOTTO.CONVENZIONE', 'Convenzione')} </h3>
                    </ div>
                </agui.aCardV4Header>

                <agui.aCardV4Body>
                    <div className="row mt-3">
                        {listProdottoConvenzione && listProdottoConvenzione.map((convenzione, index) =>
                            <div key={"mainDiv" + index} className="col-12 col-lg-12 col-md-12 col-sm-12">
                                <ConvenzioneCard
                                    key={"convenzione" + index}
                                    convenzione={convenzione}
                                    isConvenzioneToEditButton={false}
                                    disabled={!convenzione.editable}
                                    index={index}
                                    titleCard={i18n('ARM_CORE_PRODUCT.PRODOTTO.CONVENZIONE', 'Convenzione ') + (index + 1)}
                                    onClickModificaConvenzione={this.onClickModificaConvenzione}
                                    onClickEliminaConvenzione={this.showPopUP}
                                    onClickAnnullaModifica={this.onClickAnnullaModifica}
                                    onClickSalvaConvenzione={this.onClickSalvaConvenzione} />

                            </div>
                        )}
                        <ConfirmModalDeleteV4
                            show={this.props.showPopUp}
                            testoTitle={i18n('ARM_CORE_PRODUCT.CLINETS.ELIMINA.CONVENZIONE', 'Confermi di voler Eliminare? ')}
                            deleteOnClick={this.onClickEliminaConvenzione}
                            onClose={this.showPopUP} />
                    </div>
                </agui.aCardV4Body>

            </agui.aCardV4>
        );
    }

}
function mapDispatchToProps(dispatch) {
    return {


        creaNuovaConvenzione() {
            return dispatch(ProdottoActions.creaNuovaConvenzione());
        },
        salvaConvenzione(indexConvenzione) {
            return dispatch(ProdottoActions.salvaConvenzione(indexConvenzione));
        },
        getConvenzioneProdotto(idProdotto) {
            return dispatch(ProdottoActions.getConvenzioneProdotto(idProdotto));
        },

        showPopUP(isShow) {
            return dispatch(AppActions.showPopUp(isShow))
        },
        setPathNameToReturn(path) {
            return dispatch(AppActions.setPathNemeToReturn(path));
        },
        handleChangeEditConvenzione(index, parametro, value) {
            return dispatch(ProdottoActions.handleChangeEditConvenzione(index, parametro, value));
        },

        deleteConvenzione(conId) {
            return dispatch(ProdottoActions.deleteConvenzione(conId));
        },

    }
};

function mapStateToProps(state) {
    return {
        showPopUp: state.app.showPopUp,
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ListaConvenzione);